import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  formWrap: {
    margin: '20px 0 0',
  },
  btnContainer: {
    marginTop: '52px',
    marginBottom: 0,
  },
  btn: {
    minWidth: '140px',
  },
  column: {
    width: '50%',
    '&:first-child': {
      paddingRight: '30px',
    },
    '&:last-child': {
      paddingLeft: '30px',
    },
  },
}));

export default useStyles;
